import axios from 'axios'
import allBookablePersons from '../../assets/bookable_persons.json'
import allResources from '../../assets/resources.json'

export default {
  state: {
    bookablePersons: null,
    resources: null
  },
  getters: {
    getBookablePersons (state) {
      return state.bookablePersons
    },
    getResources (state) {
      return state.resources
    }
  },
  mutations: {
    setBookablePersons (state, payload) {
      state.bookablePersons = payload
    },
    setResources (state, payload) {
      state.resources = payload
    }
  },
  actions: {
    fetchBookablePersonsWithApi (context) {
      let url = process.env.VUE_APP_URLAPI
      url += '/en/wp-json/wp/v2/bookable_person'
      return new Promise((resolve, reject) => {
        axios.get(url)
          .then(response => {
            let bookablePersons = {}
            for (let i = 0; i < response.data.length; ++i) {
              bookablePersons[response.data[i].id] = response.data[i].title.rendered
            }
            context.commit('setBookablePersons', bookablePersons)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    fetchBookablePersons (context) {
      return new Promise((resolve, reject) => {
        context.commit('setBookablePersons', allBookablePersons)
        resolve()
      })
    },
    fetchResourcesWithApi (context) {
      let url = process.env.VUE_APP_URLAPI
      url += '/en/wp-json/wc-bookings/v1/resources'
      url += '?consumer_key=' + process.env.VUE_APP_CUSTOMER
      url += '&consumer_secret=' + process.env.VUE_APP_SECRET
      return new Promise((resolve, reject) => {
        axios.get(url)
          .then(response => {
            let resources = {}
            for (let i = 0; i < response.data.length; ++i) {
              resources[response.data[i].id] = response.data[i].name
            }
            context.commit('setResources', resources)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    fetchResources (context) {
      return new Promise((resolve, reject) => {
        context.commit('setResources', allResources)
        resolve()
      })
    },
    fetchStatistics (context) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_URLAPI
        url += '/wp-json/webdigit/v1/getBookingForThisDay'
        axios.get(url)
          .then(response => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}
